<template>
  <ul class="uk-navbar-nav">
    <li class="uk-Insta-link">
      <a
        href="https://www.instagram.com/nathan.nankervis/?hl=en"
        target="_blank"
        v-fancy-letters
      >
        <span class="letter1"><instagram-logo /></span>
      </a>
    </li>
    <li v-for="menuItem in data" :key="menuItem.sys.id">
      <a
        v-if="menuItem.fields.externalLink"
        :href="menuItem.fields.link"
        :class="[menuItem.fields.colour.fields.colourSlug, 'header-text--vw']"
        v-text="menuItem.fields.title"
        rel="nofollow"
        target="_blank"
        v-fancy-letters
      />
      <a
        v-else-if="
          ['/#top', '/#about', '/#contact-me'].includes(menuItem.fields.link)
        "
        @click="onLinkClick(menuItem.fields.link.substr(2))"
        :class="[menuItem.fields.colour.fields.colourSlug, 'header-text--vw']"
        v-text="menuItem.fields.title"
        v-fancy-letters
      />
      <router-link
        v-else
        :to="menuItem.fields.link"
        :class="[menuItem.fields.colour.fields.colourSlug, 'header-text--vw']"
        v-text="menuItem.fields.title"
        v-fancy-letters
      />
    </li>
  </ul>
</template>

<script>
import UIkit from 'uikit'
import InstagramLogo from '@/assets/img/white-instagram.svg'

export default {
  props: ['data'],
  components: {
    InstagramLogo,
  },
  methods: {
    toggleOverlay() {
      let dropdown = document.querySelector('#modal-work-full')
      if (dropdown.classList.contains('active')) {
        dropdown.classList.remove('active')
      } else {
        dropdown.classList.add('active')
      }

      let overlay = document.querySelector('[data-overlay]')
      let body = document.querySelector('body')
      if (overlay.classList.contains('active')) {
        overlay.classList.remove('active')
        body.classList.remove('scroll-lock')
      } else {
        overlay.classList.add('active')
        body.classList.add('scroll-lock')
      }
    },
    onLinkClick(link) {
      this.$router.push(`/#${link}`)
      this.$root.$emit('linkClick', link)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue